
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "MultipleSclerosis",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/MultipleSclerosis.vue